import PropTypes from 'prop-types';
import { formatCtaData } from '@/utils/homepageUtils';

import InfoCardList from '@/components/common/InfoCardList';
import InfoCardList2 from '@/components/common/InfoCardList/InfoCardList2';
import { ESPOT_LIST_DISPLAY, ESPOT_LIST_ORIENTATION } from '@/constants/espot';

const EspotList = ({ data }) => {
  const { listDisplay, espotsList, contentTitle, orientation, url, label } = data;

  return (
    listDisplay === ESPOT_LIST_DISPLAY.LIST_2 ? (
      <InfoCardList2 list={espotsList} title={contentTitle} orientation={orientation} url={url} label={label} />
    ) : (
      <InfoCardList data={data} cta={formatCtaData(data)} />
    )
  );
};

EspotList.propTypes = {
  data: PropTypes.shape({
    contentTitle: PropTypes.string.isRequired,
    espotsList: PropTypes.array,
    listDisplay: PropTypes.oneOf([ESPOT_LIST_DISPLAY.LIST_1, ESPOT_LIST_DISPLAY.LIST_2]),
    orientation: PropTypes.oneOf([ESPOT_LIST_ORIENTATION.LEFT, ESPOT_LIST_ORIENTATION.RIGHT]),
    url: PropTypes.string,
    label: PropTypes.string
  }).isRequired,
};
export default EspotList;
